<don-campaign-summary
  *ngIf="campaigns.length; else empty"
  [campaign]="campaigns[index]"
></don-campaign-summary>

<!-- Dots -->
<div class="dots my-3" role="tablist" aria-label="Campaigns">
  <button
    *ngFor="let c of campaigns; index as i; trackBy: trackById"
    type="button"
    class="dot"
    [class.active]="i === index"
    (click)="goTo(i)"
    [attr.aria-selected]="i === index"
    [attr.aria-label]="'Go to '+c.name">
  </button>
</div>

<ng-template #empty>
  <div class="p-4 text-center text-muted small">No campaigns</div>
</ng-template>
